interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath?: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>[];
  publishedTime?: string;
  modifiedTime?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalPath,
  ogType = 'website',
  ogImage,
  schema,
  publishedTime,
  modifiedTime,
}: SEOHeadProps) {
  const baseUrl = 'https://zfejxdp.cn';
  const fullTitle = `${title} | 水野朝阳官方粉丝站`;
  const canonical = canonicalPath ? `${baseUrl}${canonicalPath}` : baseUrl;
  const fullDescription = description.length > 160 ? description.slice(0, 157) + '...' : description;

  const metaTags: Record<string, string> = {
    'description': fullDescription,
    'keywords': keywords || '水野朝阳,水野朝阳作品,水野朝阳个人资料,水野朝阳最新动态,水野朝阳粉丝社群',
  };

  return (
    <>
      <title>{fullTitle}</title>
      {Object.entries(metaTags).map(([name, content]) => (
        <meta key={name} name={name} content={content} />
      ))}
      <link rel="canonical" href={canonical} />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="水野朝阳官方粉丝站" />
      <meta property="og:locale" content="zh_CN" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogImage && <meta property="og:image:width" content="1200" />}
      {ogImage && <meta property="og:image:height" content="630" />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {schema && schema.map((s, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(s) }}
        />
      ))}
    </>
  );
}